import script from "./VideoKeyCopy.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoKeyCopy.vue?vue&type=script&setup=true&lang=ts"

import "./VideoKeyCopy.vue?vue&type=style&index=0&id=7d43c01e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d43c01e"]])

export default __exports__